<ng-template #routerOutlet>
    <router-outlet> </router-outlet>
</ng-template>

<main id="app-root">
    <!-- <ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar> -->
    @if (currentModule === 'account') {
        <div class="container-fluid account-layout" [ngClass]="randomImageClass">
            <div class="d-flex justify-content-center align-items-center account-wrapper">
                <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
            </div>
        </div>
    }
    @if (currentModule === 'widgets') {
        <div class="container-fluid">
            <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
        </div>
    }

    @if (currentModule === 'default') {
        <div>
            @if (session.user.isAuthenticated) {
                <app-topbar></app-topbar>
            }
            <mat-sidenav-container class="container-fluid l-content" [class.bottom-menu-visible]="bottomMenuVisible" [hasBackdrop]="true">
                <mat-sidenav-content [class.limit-content-height]="sideBarOpened && canSidebarBeOpened">
                    @if (showReleaseNotesStrip) {
                        <div class="alert alert-success alert-dismissible fade show text-center mb-0" role="alert">
                            {{ 'RELEASE_NOTES.UPDATED' | translate: { version: version } }}
                            <a (click)="showReleaseNotes()" href="javascript:void(0)">{{
                                'RELEASE_NOTES.UPDATED_SHOW_RELEASE_BOTES' | translate
                            }}</a>
                            <button type="button" class="btn-close" (click)="showReleaseNotesStrip = false"></button>
                        </div>
                    }
                    @if (session.user.teamMembersCount < 4) {
                        <div class="alert alert-warning text-center" role="alert">
                            {{
                                'SETTINGS.INVITE_MORE_PLAYERS'
                                    | translate
                                        : {
                                              remaining: 4 - session.user.teamMembersCount,
                                          }
                            }}
                            <a href="javascript:void(0)" (click)="openInviteModal()">{{
                                'SETTINGS.INVITE_MORE_PLAYERS_LINK' | translate
                            }}</a>
                        </div>
                    }
                    <app-allow-push-notifications></app-allow-push-notifications>
                    <app-update-in-progress-alert></app-update-in-progress-alert>
                    @if (session.user.isAuthenticated && showSeasonSelect() && seasons().length > 1) {
                        <div class="d-flex justify-content-center pt-3">
                            <app-season-select [seasons]="seasons()" [activeSeason]="activeSeason()"></app-season-select>
                        </div>
                    }
                    <div class="container content" [class.pt-3]="seasons().length === 1">
                        <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
                    </div>
                </mat-sidenav-content>
                <mat-sidenav
                    [autoFocus]="false"
                    #sidenav
                    mode="over"
                    position="end"
                    [opened]="sideBarOpened && canSidebarBeOpened"
                    (closed)="onSidebarClosed()"
                >
                    @if (sideBarOpened && canSidebarBeOpened) {
                        <app-sidebar></app-sidebar>
                    }
                </mat-sidenav>
            </mat-sidenav-container>
            @if (session.user.isAuthenticated) {
                <app-bottom-menu-bar (visibleChanged)="bottomMenuVisible = $event"></app-bottom-menu-bar>
            }
            <footer class="footer d-none d-xxl-block">
                <div class="container">
                    <span (click)="showReleaseNotes()" class="float-right text-muted clickable">v{{ version }}</span>
                </div>
            </footer>
        </div>
    }
</main>

<swal
    #apiErrorSwal
    [title]="'COMMON.API_ERROR_MESSAGE_TITLE' | translate"
    [text]="'COMMON.API_ERROR_MESSAGE' | translate"
    icon="error"
    [footer]="swalTraceId"
>
</swal>
<swal
    #apiForbiddenSwal
    [title]="'COMMON.API_FORBIDDEN_MESSAGE_TITLE' | translate"
    [text]="'COMMON.API_FORBIDDEN_MESSAGE' | translate"
    icon="warning"
>
</swal>
<swal #apiBadRequestSwal [title]="'COMMON.API_BAD_REQUEST_MESSAGE_TITLE' | translate" [text]="apiBadRequestSwalText" icon="warning"> </swal>
